const ca = {
  common: {
    actions: {
      close: 'Tancar',
      accept: 'Acceptar',
      back: 'Enrere',
      continue: 'Continuar',
    },
    errors: {
      title: 'Error',
      unknown: 'Error desconegut.',
    },
    fields: {
      email: 'Correu electrònic',
      firstName: 'Nom',
      lastName: 'Cognom',
      country: 'País',
      city: 'Ciutat',
      postalCode: 'Codi postal',
      password: 'Contrasenya',
      confirmPassword: 'Repeteix la contrasenya',
      companyName: 'Nom de l’empresa',
      userType: 'Tipus d’usuari',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
    },
    userTypes: {
      person: 'Autònom',
      company: 'Empresa',
    },
  },

  paymentCancelled: {
    title: 'Pagament cancel·lat',
    description:
      'El procés de pagament s’ha cancel·lat. Si ha estat un error, ho pots tornar a intentar.',
  },

  paymentSuccess: {
    title: 'Pagament realitzat amb èxit!',
    descriptionDemo:
      'Ja pots <link>accedir</link> i gaudir de tots els avantatges de la nostra plataforma.',
    descriptionStandard:
      'Hem enviat un correu electrònic amb els detalls de la teva subscripció. Si us plau, revisa la safata d’entrada i segueix les instruccions per completar el procés.',
  },

  registration: {
    title: 'Començar registre',
    titleDemo: 'Començar registre en demo',
    complete: 'Completa',
    stepsCount: '3 passos',
    toCreateAccount: 'per crear el teu compte',
    planFallback: 'Pla',
    planSelection: 'Selecció de pla',
    expensesTotalUsers: 'Total: {{total}} usuaris a Billivo Expenses ({{base}} inclosos al pla)',
    inviteApplied:
      'Invitació de la teva gestoria aplicada: 50 € de descompte en el pla anual Business Advance + Acceso al Contable.',
    inviteRequiresPlan:
      "La teva gestoria et convida amb 50 € de descompte. El descompte s'aplica al pla Business Advance + Acceso al Contable amb facturació anual.",

    steps: {
      account: 'Compte',
      userData: 'Dades de l’usuari',
      addressAndConfirmation: 'Adreça i confirmació',
      planAndAccount: 'Pla i compte',
    },

    userTypes: {
      person: 'Autònom',
      company: 'Companyia',
      agent: 'Gestor',
    },

    fields: {
      agentName: 'Nom del gestor',
      agentDocument: 'NIF/CIF/NIE',
      agentVatId: 'VAT ID',
      agentPhoneNumber: 'Número de telèfon',
      agentWebsite: 'Web',
      referralOptIn: 'Vols participar en el sistema de referits de gestor?',
      subscriptionPlan: 'Pla de subscripció',
      billingPeriod: 'Període de facturació',
      expensesPacks: 'Paquets extra de Billivo Expenses (10 usuaris cadascun)',
      userType: 'Tipus d’usuari',
      companyName: 'Nom de l’empresa',
      firstName: 'Nom',
      lastName: 'Cognom',
      email: 'Correu electrònic',
      password: 'Contrasenya',
      confirmPassword: 'Repeteix la contrasenya',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      vatId: 'VAT ID',
      phoneNumber: 'Número de telèfon',
      taxType: 'Tipus d’impost',
      addressLine1: 'Línia d’adreça 1',
      addressLine2: 'Línia d’adreça 2',
      postalCode: 'Codi postal',
      city: 'Ciutat',
      country: 'País',
      discountCode: 'Codi de descompte',
      referredByCode: 'Codi de referència',
    },

    billing: {
      monthly: 'Mensual',
      yearly: 'Anual',
      popular: 'Popular',
      save17: 'Estalvi 17%',
      monthShort: 'mes',
      yearShort: 'any',
    },

    taxTypes: {
      peninsula: '01 - Península',
      ceutaMelilla: '02 - Ceuta i Melilla',
      canaryIslands: '03 - Illes Canàries',
      other: '05 - Altres',
    },

    api: {
      devOnly: '⚙️ [NOMÉS PER A DESENVOLUPADORS]',
      useApi: 'Vull utilitzar l’API de Billivo',
      numberingManagement: 'Gestió de numeració',
      selectOption: 'Selecciona una opció',
      erpOption: 'Vull controlar jo mateix la numeració de factures',
      noErpOption: 'Desitjo que Billivo gestioni la numeració',
    },

    accessibility: {
      showPassword: 'Mostrar contrasenya',
      hidePassword: 'Ocultar contrasenya',
      showConfirmPassword: 'Mostrar confirmació',
      hideConfirmPassword: 'Ocultar confirmació',
    },

    actions: {
      continue: 'Continuar',
      back: 'Enrere',
      sending: 'Enviant...',
      finishRegistration: 'Finalitzar registre',
      close: 'Tancar',
      accept: 'Acceptar',
    },

    status: {
      sendingInfo: 'Enviant informació...',
    },

    errors: {
      title: 'Error',
      unknown: 'Error desconegut.',
      submitUnknown: 'Error desconegut en enviar el formulari',
      stripeLoadFailed: 'Stripe no s’ha pogut carregar.',
      noSession: 'No hi ha cap sessió per redirigir',
    },

    validation: {
      invalidWebsite: 'La web no és vàlida',
      validOption: 'Selecciona una opció vàlida',
      apiUsageTypeRequired: 'Selecciona com gestionar la numeració',
      emailRequired: 'El correu electrònic és obligatori',
      invalidEmail: 'Correu electrònic no vàlid',
      companyNameRequired: 'El nom de la companyia és obligatori',
      firstNameRequired: 'El nom és obligatori',
      lastNameRequired: 'El cognom és obligatori',
      nationalIdRequired: 'NIF/NIE/CIF és obligatori',
      invalidDocument: 'Document no vàlid',
      invalidCif: 'CIF no vàlid',
      invalidNifNie: 'NIF/NIE no vàlid',
      taxTypeRequired: 'El tipus d’impost és obligatori',
      phoneRequired: 'El número de telèfon és obligatori',
      addressRequired: 'L’adreça és obligatòria',
      postalCodeRequired: 'El codi postal és obligatori',
      cityRequired: 'La ciutat és obligatòria',
      countryRequired: 'El país és obligatori',
      billingPeriodRequired: 'El període de facturació és obligatori',
      passwordRequired: 'La contrasenya és obligatòria',
      passwordMin: 'Mínim 8 caràcters',
      confirmPasswordRequired: 'Repeteix la contrasenya',
      passwordsDoNotMatch: 'Les contrasenyes no coincideixen',
      maxLength: 'Màxim {{max}} caràcters',
      maxValue: 'Màxim {{max}}',
    },

    terms: {
      acceptPrefix: 'Accepto els',
      linkText: 'termes i condicions',
      title: 'Termes i Condicions',
      sections: {
        general: {
          title: '1. Informació general i acceptació',
          body: 'Aquests termes i condicions regulen l’accés i l’ús de Billivo.',
        },
        definitions: {
          title: '2. Definicions',
          body: 'Usuari: persona física que utilitza Billivo. Serveis: funcionalitats ofertes a través de Billivo. Contingut: qualsevol informació o material disponible a Billivo.',
        },
        scope: {
          title: '3. Objecte i abast',
          body: 'Billivo permet als usuaris accedir als serveis oferts per l’empresa.',
        },
        access: {
          title: '4. Alta i accés',
          body: 'Pot ser necessari registrar-se i crear un compte amb dades veraces i actualitzades.',
        },
        usage: {
          title: '5. Ús de Billivo',
          body: 'L’usuari es compromet a utilitzar Billivo de manera lícita i de bona fe.',
        },
        privacy: {
          title: '6. Privacitat i protecció de dades',
          body: 'La recollida i el tractament de dades personals es regeixen per la normativa vigent.',
        },
        communications: {
          title: '7. Comunicacions comercials i butlletins',
          body: 'En acceptar aquests termes, l’usuari autoritza determinades comunicacions relacionades amb Billivo.',
        },
        intellectualProperty: {
          title: '8. Propietat intel·lectual i industrial',
          body: 'Tots els drets sobre Billivo i els seus continguts pertanyen a l’empresa o a tercers autoritzats.',
        },
        liability: {
          title: '9. Exclusió de garanties i responsabilitat',
          body: 'L’empresa no garanteix la disponibilitat contínua de Billivo en tots els casos.',
        },
        thirdPartyLinks: {
          title: '10. Enllaços a llocs de tercers',
          body: 'Billivo pot incloure enllaços a llocs de tercers, sense responsabilitzar-se del seu contingut.',
        },
        modifications: {
          title: '11. Modificació dels Termes',
          body: 'L’empresa podrà modificar aquests termes quan ho consideri necessari.',
        },
        termination: {
          title: '12. Terminació',
          body: 'L’empresa podrà suspendre o cancel·lar l’accés en cas d’incompliment o ús fraudulent.',
        },
        jurisdiction: {
          title: '13. Llei aplicable i jurisdicció',
          body: 'Aquests termes es regeixen per la legislació espanyola.',
        },
        contact: {
          title: '14. Contacte',
          body: 'Per a qualsevol dubte, l’usuari pot contactar amb l’empresa per correu electrònic.',
        },
      },
    },
  },

  registrationSuccess: {
    title: 'Registre realitzat amb èxit!',
    descriptionDemo:
      'Ja pots <link>accedir</link> i gaudir de tots els avantatges de la nostra plataforma.',
    descriptionStandard:
      'Hem enviat un correu electrònic amb els detalls del teu registre. Si us plau, revisa la safata d’entrada i segueix les instruccions per completar el procés.',

    apiCredentials: {
      title: 'Credencials d’API - IMPORTANT!',
      warning:
        'Aquesta contrasenya <strong>NO s’ha desat</strong> i només es mostrarà una vegada. Desa-la en un lloc segur abans de sortir d’aquesta pàgina.',
      emailLabel: 'Correu electrònic:',
      passwordLabel: 'Contrasenya:',
    },

    snackbar: {
      copied: '{{field}} copiat al porta-retalls',
      email: 'Correu electrònic',
      password: 'Contrasenya',
    },
  },

  simpleForm: {
    title: 'Registre ràpid',
    subtitle: 'Completa el formulari i en finalitzar et mostrarem el teu QR.',
    optional: 'Opcional',
    fields: {
      country: 'País',
      userType: 'Tipus d’usuari',
      firstName: 'Nom',
      lastName: 'Cognom',
      companyName: 'Nom de l’empresa',
      email: 'Correu electrònic',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      taxId: 'Número d’identificació fiscal',
      taxIdOptional: 'Número d’identificació fiscal (opcional)',
    },
    userTypes: {
      person: 'Autònom',
      company: 'Empresa',
    },
    helpers: {
      companyCif: 'Introdueix el CIF de l’empresa',
      personNifNie: 'Introdueix el teu NIF o NIE',
      euRequired: 'Aquest camp és obligatori per a clients de la UE',
      outsideEuOptional: 'Pots completar-lo si disposes d’identificació fiscal',
    },
    validation: {
      countryRequired: 'El país és obligatori',
      userTypeRequired: 'El tipus d’usuari és obligatori',
      emailRequired: 'El correu electrònic és obligatori',
      invalidEmail: 'Correu electrònic no vàlid',
      companyNameRequired: 'El nom de la companyia és obligatori',
      firstNameRequired: 'El nom és obligatori',
      lastNameRequired: 'El cognom és obligatori',
      nationalIdRequiredSpain: 'NIF/NIE/CIF és obligatori',
      invalidDocument: 'Document no vàlid',
      invalidCif: 'CIF no vàlid',
      invalidNifNie: 'NIF/NIE no vàlid',
      taxIdRequired: 'El número d’identificació fiscal és obligatori',
    },
    actions: {
      register: 'Registrar-me',
      registering: 'Registrant...',
      close: 'Tancar',
      accept: 'Acceptar',
    },
    status: {
      sending: 'Enviant informació...',
    },
    errors: {
      title: 'Error',
      unknownError: 'Error desconegut.',
      submitError: 'Error desconegut en enviar el formulari',
    },
    terms: {
      acceptPrefix: 'Accepto els',
      linkText: 'termes i condicions',
      title: 'Termes i Condicions',
      sections: {
        general: {
          title: '1. Informació general i acceptació',
          body: 'Aquests termes i condicions (els "Termes") regulen l’accés i l’ús de l’aplicació mòbil i/o web (d’ara endavant Billivo) desenvolupada per Code10 IT Consultants S.L. Si no esteu d’acord amb els Termes, no utilitzeu Billivo.',
        },
        definitions: {
          title: '2. Definicions',
          body: 'Usuari: la persona física que, un cop acceptats aquests Termes, utilitza Billivo independentment de si actua en nom propi o en representació d’un tercer.',
        },
        scope: {
          title: '3. Objecte i abast',
          body: 'Billivo permet als Usuaris accedir als Serveis oferts per l’empresa. L’ús de Billivo té caràcter personal i no comercial.',
        },
        access: {
          title: '4. Alta i accés',
          body: 'Per utilitzar determinats Serveis pot ser necessari registrar-se i crear un compte, facilitant dades veraces i actualitzades. L’Usuari és responsable de custodiar les seves credencials.',
        },
        usage: {
          title: '5. Ús de Billivo',
          body: 'L’Usuari es compromet a utilitzar Billivo de manera lícita, de bona fe i sense contravenir l’ordenament jurídic.',
        },
        privacy: {
          title: '6. Privacitat i protecció de dades',
          body: 'La recollida i el tractament de dades personals es regeixen per la Política de Privacitat i la normativa vigent aplicable.',
        },
        communications: {
          title: '7. Comunicacions comercials i butlletins',
          body: 'En acceptar aquests Termes i donar-se d’alta a Billivo, l’Usuari autoritza expressament l’empresa a utilitzar la seva adreça de correu electrònic i altres dades de contacte per enviar-li comunicacions.',
        },
        intellectualProperty: {
          title: '8. Propietat intel·lectual i industrial',
          body: 'Tots els drets de propietat intel·lectual i industrial sobre Billivo, els seus codis font, disseny, continguts, logotips i marques pertanyen a l’empresa o a tercers que n’han autoritzat l’ús.',
        },
        liability: {
          title: '9. Exclusió de garanties i responsabilitat',
          body: 'L’empresa no garanteix la disponibilitat, continuïtat ni infal·libilitat de Billivo i queda exempta de responsabilitat en la mesura permesa per la llei.',
        },
        thirdPartyLinks: {
          title: '10. Enllaços a llocs de tercers',
          body: 'Billivo pot incloure enllaços a llocs web o continguts de tercers. L’empresa no controla aquests llocs i no és responsable del seu contingut.',
        },
        modifications: {
          title: '11. Modificació dels Termes',
          body: 'L’empresa podrà modificar aquests Termes quan ho consideri necessari. Les modificacions entraran en vigor des de la seva publicació.',
        },
        termination: {
          title: '12. Terminació',
          body: 'L’empresa podrà suspendre o cancel·lar l’accés de l’Usuari quan detecti incompliments, ús fraudulent o contrari a la llei.',
        },
        jurisdiction: {
          title: '13. Llei aplicable i jurisdicció',
          body: 'Aquests Termes es regeixen per la legislació espanyola. Per a la resolució de conflictes, les parts se sotmeten als jutjats i tribunals competents.',
        },
        contact: {
          title: '14. Contacte',
          body: 'Per a qualsevol dubte o consulta, l’Usuari pot posar-se en contacte amb l’empresa enviant un correu electrònic a support@billivo.com.',
        },
      },
    },
  },

  simpleFormSuccess: {
    notFound: {
      title: 'No s’ha trobat el registre',
      description: 'No tenim informació suficient per mostrar el QR.',
      backButton: 'Tornar al formulari',
    },
    success: {
      title: 'Registre realitzat amb èxit!',
      description:
        'El teu usuari s’ha creat correctament. Desa aquest QR i ensenya’l al conductor perquè pugui emetre la teva factura.',
    },
    temporaryPassword: {
      title: 'Contrasenya temporal',
      description:
        'Aquesta contrasenya s’ha generat automàticament i s’haurà de canviar en el primer accés.',
      emailLabel: 'Correu electrònic:',
      passwordLabel: 'Contrasenya temporal:',
    },
    snackbar: {
      copied: '{{field}} copiat al porta-retalls',
      email: 'Correu electrònic',
      temporaryPassword: 'Contrasenya temporal',
    },
  },
};

export default ca;
